(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rp-analytics"));
	else if(typeof define === 'function' && define.amd)
		define(["rp-analytics"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var BREAKPOINTS = exports.BREAKPOINTS = {
    TABLET: 719.9,
    DESKTOP: 989.9
};

var isMobile = exports.isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
var isTabletBeakpoint = exports.isTabletBeakpoint = window.screen.width > 719;
var isDesktopBeakpoint = exports.isDesktopBeakpoint = window.screen.width > 989.9;

var isRacecardsOrResults = exports.isRacecardsOrResults = window.location.pathname.includes('/racecards/') || window.location.pathname.includes('/results/') || window.location.pathname.includes('/fast-results/');

var tierBookmakers = exports.tierBookmakers = {
    tierOne: 'Tier 1',
    tierTwo: 'Tier 2'
};

var BOOKMAKER_STATUS = exports.BOOKMAKER_STATUS = {
    OPEN: 'open',
    CLOSE: 'close'
};

var BOOKMAKER_ANALYTICS = exports.BOOKMAKER_ANALYTICS = {
    MORE_OFFERS_TITLE: 'More Offers',
    TODAYS_OFFERS_TITLE: "Today's Offers",
    TODAYS_OFFERS_TITLE_QUICK_LINK: "Today's Offers - Quick Link"
};

var COUNTRY_CODES = exports.COUNTRY_CODES = {
    IRE: 'IRE',
    IE: 'IE'
};

var CURRENCY_SYMBOLS = exports.CURRENCY_SYMBOLS = {
    GBP: '£',
    EUR: '€'
};

var BOOKMAKER_OFFER_TYPE = exports.BOOKMAKER_OFFER_TYPE = {
    TIER_ONE: 'Tier 1',
    EXCLUSIVE: 'Exclusive'
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderByPosition = undefined;

var _shuffleArray = __webpack_require__(27);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var orderByPosition = exports.orderByPosition = function orderByPosition(offers) {
    var withPosition = [];
    var nonPositioned = [];
    offers.forEach(function (offer) {
        if (offer.position && offer.position !== 0) {
            withPosition.push(offer);
        } else nonPositioned.push(offer);
    });

    return [].concat(_toConsumableArray(withPosition.sort(function (a, b) {
        return a.position - b.position;
    })), _toConsumableArray((0, _shuffleArray.shuffleArray)(nonPositioned, new Date().getTime())));
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},

  activeElement: {
    blur: function blur() {},

    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},

  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}

exports.a = getWindow;
exports.g = getDocument;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceCurrencySigns = undefined;

var _constants = __webpack_require__(0);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var replaceCurrencySigns = exports.replaceCurrencySigns = function replaceCurrencySigns() {
    var oddsComparisonPrices = document.getElementsByClassName('RC-oddsRaceContent__dataOffer');
    var betPopupsHeadline = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverHeadline');
    var betPopupsOffer = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverOffer');
    var chooseBookieOffers = document.getElementsByClassName('RC-chooseBookieMobile__buttonFreeBet');

    Array.from([].concat(_toConsumableArray(oddsComparisonPrices), _toConsumableArray(betPopupsHeadline), _toConsumableArray(betPopupsOffer), _toConsumableArray(chooseBookieOffers))).forEach(function (element) {
        // eslint-disable-next-line
        element.innerHTML = element.innerHTML.replaceAll(_constants.CURRENCY_SYMBOLS.GBP, _constants.CURRENCY_SYMBOLS.EUR);
    });
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var BUTTON_TEXT = exports.BUTTON_TEXT = 'CLAIM OFFER';

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBookmakersToShow = exports.shouldShowBookmaker = undefined;

var _constants = __webpack_require__(0);

var _localStorageHandlers = __webpack_require__(25);

/**
 * Filters out bookmakers that the user has either:
 * - Marked as having an account with during the bookmaker quiz
 * - Recently logged into
 *
 * Quiz location: 'https://www.racingpost.com/free-bets/bookmakers-quiz/'
 *
 * @param {Array} offers - List of bookmaker offers to filter.
 *
 * Excluded bookmakers are determined based on stored user data:s
 * - `__user_traits` (stores bookmakers selected in the quiz)
 * - `__recent_bookmakers` (stores recently logged-in bookmakers)
 *
 * @returns {Array} - A filtered list of bookmakers that are still eligible to be shown.
 * NOTE: It's valid only for TIER ONE bookmaker offers.
 */

/* eslint-disable no-multi-spaces, arrow-parens, import/prefer-default-export */
var getTransformedBookmakerName = function getTransformedBookmakerName(bookmaker, type, isContainInQuiz) {
    if (isContainInQuiz) {
        var bookmakerNameQuiz = type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '_') : bookmaker.name.toLowerCase().replace(' ', '_');

        return bookmakerNameQuiz.includes('skybet') ? 'sky_bet_quiz' : bookmakerNameQuiz + '_quiz';
    }

    return type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '') : bookmaker.name.toLowerCase().replace(' ', '');
};

var shouldShowBookmaker = exports.shouldShowBookmaker = function shouldShowBookmaker(bookmaker, type) {
    var userTraits = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('__user_traits') || '{}');
    var recentBookmakers = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('recentBookmakers') || '{}');
    var isTierOne = bookmaker.isTierOne || Number(bookmaker.bookmaker_tier) === 1;

    if (!isTierOne) {
        return true;
    }

    return !userTraits[getTransformedBookmakerName(bookmaker, type, true)] && !recentBookmakers[getTransformedBookmakerName(bookmaker, type, false)];
};

var getBookmakersToShow = exports.getBookmakersToShow = function getBookmakersToShow(bookmakerOffers, type) {
    return bookmakerOffers.filter(function (bookmaker) {
        return shouldShowBookmaker(bookmaker, type);
    });
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookmakersExclusiveOffersPanel = __webpack_require__(16);

var _bookmakersExclusiveOffersPanel2 = _interopRequireDefault(_bookmakersExclusiveOffersPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Tranfsorm bookmakers and filter
 * by display_offer to be visible in the carousel
 *
 * @param { Object } bookmakers
 * @returns { desktopBookmakers, mobileBookmakers }
 *
 */
var transformBookmakersExclusive = function transformBookmakersExclusive(bookmakers) {
    var desktopBookmakers = [];
    var mobileBookmakers = [];

    // eslint-disable-next-line no-restricted-syntax
    for (var bookmakerKey in bookmakers) {
        if (bookmakers[bookmakerKey].desktop && bookmakers[bookmakerKey].desktop.display_offer === 'true' && bookmakers[bookmakerKey].desktop.name !== null) {
            desktopBookmakers.push(bookmakers[bookmakerKey].desktop);
        }

        if (bookmakers[bookmakerKey].mobile && bookmakers[bookmakerKey].mobile.display_offer === 'true' && bookmakers[bookmakerKey].mobile.name !== null) {
            mobileBookmakers.push(bookmakers[bookmakerKey].mobile);
        }
    }

    return { desktopBookmakers: desktopBookmakers, mobileBookmakers: mobileBookmakers };
};

var fetchBookmakerExclusiveOffers = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-exclusive-offers/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            var _transformBookmakersE = transformBookmakersExclusive(data.exclusiveOffers),
                                desktopBookmakers = _transformBookmakersE.desktopBookmakers,
                                mobileBookmakers = _transformBookmakersE.mobileBookmakers;

                            (0, _bookmakersExclusiveOffersPanel2.default)(desktopBookmakers, mobileBookmakers);
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakerExclusiveOffers() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakerExclusiveOffers;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _orderByPosition = __webpack_require__(1);

var _replaceCurrencySigns = __webpack_require__(4);

var _renderPromotedTierTwoBookmakers = __webpack_require__(20);

var _renderPromotedTierTwoBookmakers2 = _interopRequireDefault(_renderPromotedTierTwoBookmakers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchBookmakersMixedTier = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-mixed-tier/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
                            }

                            var bookmakerOffersTierTwoDesktop = data.bookmakerOffersTierTwoDesktop,
                                bookmakerOffersTierTwoMobile = data.bookmakerOffersTierTwoMobile;

                            // NOTE: Order by position regarding requirements of [JP-10686]

                            (0, _renderPromotedTierTwoBookmakers2.default)((0, _orderByPosition.orderByPosition)(bookmakerOffersTierTwoDesktop), (0, _orderByPosition.orderByPosition)(bookmakerOffersTierTwoMobile));
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersMixedTier() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersMixedTier;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _renderTierOneBookmakers = __webpack_require__(22);

var _renderTierOneBookmakers2 = _interopRequireDefault(_renderTierOneBookmakers);

var _orderByPosition = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchBookmakersTierOne = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-one/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            (0, _renderTierOneBookmakers2.default)((0, _orderByPosition.orderByPosition)(data.bookmakerOffersDesktop), (0, _orderByPosition.orderByPosition)(data.bookmakerOffersMobile), data.freeBetsDesktopOffers, data.freeBetsMobileOffers);
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for tier 1 bookmaker offer', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersTierOne() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersTierOne;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _orderByPosition = __webpack_require__(1);

var _bookmakersTierTwoPanel = __webpack_require__(18);

var _bookmakersTierTwoPanel2 = _interopRequireDefault(_bookmakersTierTwoPanel);

var _replaceCurrencySigns = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var transformBookmakersTierTwo = function transformBookmakersTierTwo(bookmakers) {
    var bookmakerOffersTierTwoDesktop = bookmakers.bookmakerOffersTierTwoDesktop,
        bookmakerOffersTierTwoMobile = bookmakers.bookmakerOffersTierTwoMobile;

    // Those offers are used for T2/T3 bookmaker offers panel

    var moreOffersBookmakers = _constants.isMobile ? bookmakerOffersTierTwoMobile : bookmakerOffersTierTwoDesktop;
    var filteredMoreOffers = moreOffersBookmakers.filter(function (bookmaker) {
        return bookmaker.name && bookmaker.includeInTier2Panel;
    });
    var filteredMoreOffersBookmakers = (0, _orderByPosition.orderByPosition)(filteredMoreOffers);

    return { filteredMoreOffersBookmakers: filteredMoreOffersBookmakers };
};

var fetchBookmakersTierTwo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-two/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            var _transformBookmakersT = transformBookmakersTierTwo(data),
                                filteredMoreOffersBookmakers = _transformBookmakersT.filteredMoreOffersBookmakers;

                            if (_constants.isRacecardsOrResults) {
                                (0, _bookmakersTierTwoPanel2.default)(filteredMoreOffersBookmakers);
                            }

                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
                            }
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersTierTwo() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersTierTwo;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var BOOKMAKERS_DISPLAY_NAME = {
    matchbook: 'Matchbook',
    netbet: 'Netbet',
    sbk: 'SBK',
    copybet: 'CopyBet',
    kwiff: 'Kwiff',
    boylesports: 'Boyle Sports',
    unibet: 'Unibet',
    parimatch: 'Parimatch',
    spreadex: 'SpreadEx',
    planetsports: 'Planet Sports',
    easybet: 'EasyBet',
    bet365: 'bet365',
    skybet: 'SkyBet',
    coral: 'Coral',
    ladbrokes: 'Ladbrokes',
    paddypower: 'Paddy Power',
    betfair: 'Betfair',
    williamhill: 'William Hill',
    tote: 'Tote',
    betmgm: 'BetMGM',
    betway: 'Betway',
    livescore: 'Livescore',
    virginbet: 'Virgin Bet',
    midnite: 'Midnite',
    bzeebet: 'Bzeebet',
    betfred: 'Betfred',
    betgoodwin: 'BetGoodwin',
    starsports: 'Star Sports',
    '10bet': '10Bet',
    jeffbet: 'JeffBet'
};

/* eslint-disable import/prefer-default-export */
var getBookmakersName = exports.getBookmakersName = function getBookmakersName(name) {
    return BOOKMAKERS_DISPLAY_NAME[name.toLowerCase().replace(' ', '')];
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.d = exports.S = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ssrWindowEsm = __webpack_require__(3);

var _utils = __webpack_require__(14);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var support = void 0;
function calcSupport() {
  var window = (0, _ssrWindowEsm.a)();
  var document = (0, _ssrWindowEsm.g)();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

var deviceCached = void 0;
function calcDevice(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      userAgent = _ref3.userAgent;

  var support = getSupport();
  var window = (0, _ssrWindowEsm.a)();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel';

  // iPadOs 13 fix
  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + 'x' + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

var browser = void 0;
function calcBrowser() {
  var window = (0, _ssrWindowEsm.a)();
  var device = getDevice();
  var needPerspectiveFix = false;
  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    var ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      var _ua$split$1$split$0$s = ua.split('Version/')[1].split(' ')[0].split('.').map(function (num) {
        return Number(num);
      }),
          _ua$split$1$split$0$s2 = _slicedToArray(_ua$split$1$split$0$s, 2),
          major = _ua$split$1$split$0$s2[0],
          minor = _ua$split$1$split$0$s2[1];

      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  var isSafariBrowser = isSafari();
  var need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix: needPerspectiveFix,
    need3dFix: need3dFix,
    isWebView: isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize(_ref) {
  var swiper = _ref.swiper,
      on = _ref.on,
      emit = _ref.emit;

  var window = (0, _ssrWindowEsm.a)();
  var observer = null;
  var animationFrame = null;
  var resizeHandler = function resizeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  var createObserver = function createObserver() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(function (entries) {
      animationFrame = window.requestAnimationFrame(function () {
        var width = swiper.width,
            height = swiper.height;

        var newWidth = width;
        var newHeight = height;
        entries.forEach(function (_ref2) {
          var contentBoxSize = _ref2.contentBoxSize,
              contentRect = _ref2.contentRect,
              target = _ref2.target;

          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  var removeObserver = function removeObserver() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  var orientationChangeHandler = function orientationChangeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', function () {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', function () {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  var swiper = _ref.swiper,
      extendParams = _ref.extendParams,
      on = _ref.on,
      emit = _ref.emit;

  var observers = [];
  var window = (0, _ssrWindowEsm.a)();
  var attach = function attach(target, options) {
    if (options === void 0) {
      options = {};
    }
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      var observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  var init = function init() {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = (0, _utils.a)(swiper.hostEl);
      for (var i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  var destroy = function destroy() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    var events = void 0;
    var data = void 0;
    var context = void 0;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(_toConsumableArray(data)));
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width = void 0;
  var height = void 0;
  var el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt((0, _utils.o)(el, 'padding-left') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-right') || 0, 10);
  height = height - parseInt((0, _utils.o)(el, 'padding-top') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  var params = swiper.params;
  var wrapperEl = swiper.wrapperEl,
      slidesEl = swiper.slidesEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = (0, _utils.e)(slidesEl, '.' + swiper.params.slideClass + ', swiper-slide');
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;

  // reset margins
  slides.forEach(function (slideEl) {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', '');
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', '');
  }
  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  var slideSize = void 0;
  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function (key) {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = void 0;
    if (slides[i]) _slide = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, _slide, slides);
    }
    if (slides[i] && (0, _utils.o)(_slide, 'display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[swiper.getDirectionLabel('width')] = '';
      }
      var slideStyles = getComputedStyle(_slide);
      var currentTransform = _slide.style.transform;
      var currentWebKitTransform = _slide.style.webkitTransform;
      if (currentTransform) {
        _slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? (0, _utils.f)(_slide, 'width', true) : (0, _utils.f)(_slide, 'height', true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide2 = _slide,
              clientWidth = _slide2.clientWidth,
              offsetWidth = _slide2.offsetWidth;

          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        _slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[swiper.getDirectionLabel('width')] = slideSize + 'px';
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = swiper.virtualSize + spaceBetween + 'px';
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = swiper.virtualSize + spaceBetween + 'px';
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    var newSlidesGrid = [];
    for (var _i = 0; _i < snapGrid.length; _i += 1) {
      var slidesGridItem = snapGrid[_i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    var size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      var groupSize = size * params.slidesPerGroup;
      for (var _i2 = 0; _i2 < groups; _i2 += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (var _i3 = 0; _i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; _i3 += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(function (slideEl) {
      slideEl.style[key] = spaceBetween + 'px';
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    _allSlidesSize -= spaceBetween;
    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', -snapGrid[0] + 'px');
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2 + 'px');
    var addToSnapGrid = -swiper.snapGrid[0];
    var addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(function (v) {
      return v + addToSnapGrid;
    });
    swiper.slidesGrid = swiper.slidesGrid.map(function (v) {
      return v + addToSlidesGrid;
    });
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    var backFaceHiddenClass = params.containerModifierClass + 'backface-hidden';
    var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i = void 0;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = newHeight + 'px';
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  // eslint-disable-next-line
  var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }
  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate,
      snapGrid = swiper.snapGrid;

  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.forEach(function (slideEl) {
    slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  var spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (var i = 0; i < slides.length; i += 1) {
    var _slide3 = slides[i];
    var slideOffset = _slide3.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
    var slideBefore = -(offsetCenter - slideOffset);
    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(_slide3);
      swiper.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    if (isFullyVisible) {
      slides[i].classList.add(params.slideFullyVisibleClass);
    }
    _slide3.progress = rtl ? -slideProgress : slideProgress;
    _slide3.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  var swiper = this;
  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd,
      progressLoop = swiper.progressLoop;

  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    var firstSlideIndex = swiper.getSlideIndexByData(0);
    var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    var translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress: progress,
    progressLoop: progressLoop,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      slidesEl = swiper.slidesEl,
      activeIndex = swiper.activeIndex;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  var getFilteredSlide = function getFilteredSlide(selector) {
    return (0, _utils.e)(slidesEl, '.' + params.slideClass + selector + ', swiper-slide' + selector)[0];
  };
  slides.forEach(function (slideEl) {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  var activeSlide = void 0;
  var prevSlide = void 0;
  var nextSlide = void 0;
  if (isVirtual) {
    if (params.loop) {
      var slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + slideIndex + '"]');
    } else {
      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + activeIndex + '"]');
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex;
      })[0];
      nextSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex + 1;
      })[0];
      prevSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex - 1;
      })[0];
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    // Active classes
    activeSlide.classList.add(params.slideActiveClass);
    if (gridEnabled) {
      if (nextSlide) {
        nextSlide.classList.add(params.slideNextClass);
      }
      if (prevSlide) {
        prevSlide.classList.add(params.slidePrevClass);
      }
    } else {
      // Next Slide
      nextSlide = (0, _utils.p)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }
      if (nextSlide) {
        nextSlide.classList.add(params.slideNextClass);
      }

      // Prev Slide
      prevSlide = (0, _utils.q)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
      if (prevSlide) {
        prevSlide.classList.add(params.slidePrevClass);
      }
    }
  }
  swiper.emitSlidesClasses();
}

var processLazyPreloader = function processLazyPreloader(swiper, imageEl) {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  var slideSelector = function slideSelector() {
    return swiper.isElement ? 'swiper-slide' : '.' + swiper.params.slideClass;
  };
  var slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    var lazyEl = slideEl.querySelector('.' + swiper.params.lazyPreloaderClass);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
      } else {
        // init later
        requestAnimationFrame(function () {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
var unlazy = function unlazy(swiper, index) {
  if (!swiper.slides[index]) return;
  var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
var preload = function preload(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  var amount = swiper.params.lazyPreloadPrevNext;
  var len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  var activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    var activeColumn = activeIndex;
    var preloadColumns = [activeColumn - amount];
    preloadColumns.push.apply(preloadColumns, _toConsumableArray(Array.from({
      length: amount
    }).map(function (_, i) {
      return activeColumn + slidesPerView + i;
    })));
    swiper.slides.forEach(function (slideEl, i) {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  var slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      var realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (var _i4 = Math.max(activeIndex - amount, 0); _i4 <= Math.min(slideIndexLastInView + amount, len - 1); _i4 += 1) {
      if (_i4 !== activeIndex && (_i4 > slideIndexLastInView || _i4 < activeIndex)) {
        unlazy(swiper, _i4);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  var slidesGrid = swiper.slidesGrid,
      params = swiper.params;

  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var activeIndex = void 0;
  for (var i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;

  var activeIndex = newActiveIndex;
  var snapIndex = void 0;
  var getVirtualRealIndex = function getVirtualRealIndex(aIndex) {
    var realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  var realIndex = void 0;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    var firstSlideInColumn = swiper.slides.filter(function (slideEl) {
      return slideEl.column === activeIndex;
    })[0];
    var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex: previousSnapIndex,
    snapIndex: snapIndex,
    previousRealIndex: previousRealIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  var swiper = this;
  var params = swiper.params;
  var slide = el.closest('.' + params.slideClass + ', swiper-slide');
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [].concat(_toConsumableArray(path.slice(path.indexOf(el) + 1, path.length))).forEach(function (pathEl) {
      if (!slide && pathEl.matches && pathEl.matches('.' + params.slideClass + ', swiper-slide')) {
        slide = pathEl;
      }
    });
  }
  var slideFound = false;
  var slideIndex = void 0;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }
  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      wrapperEl = swiper.wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  var currentTranslate = (0, _utils.i)(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;

  var x = 0;
  var y = 0;
  var z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
  }

  // Check if we need to update progress
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate = void 0;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      var _wrapperEl$scrollTo;

      if (!swiper.support.smoothScroll) {
        (0, _utils.r)({
          swiper: swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty(_wrapperEl$scrollTo, 'behavior', 'smooth'), _wrapperEl$scrollTo));
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = duration + 'ms';
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? '0ms' : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  var swiper = _ref.swiper,
      runCallbacks = _ref.runCallbacks,
      direction = _ref.direction,
      step = _ref.step;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit('transition' + step);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransition' + step);
      return;
    }
    swiper.emit('slideChangeTransition' + step);
    if (dir === 'next') {
      swiper.emit('slideNextTransition' + step);
    } else {
      swiper.emit('slidePrevTransition' + step);
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params;

  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params;

  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'End'
  });
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial || swiper.destroyed) {
    return false;
  }
  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  var translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  var direction = void 0;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = rtl ? translate : -translate;
    if (speed === 0) {
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(function () {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(function () {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      var _wrapperEl$scrollTo2;

      if (!swiper.support.smoothScroll) {
        (0, _utils.r)({
          swiper: swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty(_wrapperEl$scrollTo2, isH ? 'left' : 'top', t), _defineProperty(_wrapperEl$scrollTo2, 'behavior', 'smooth'), _wrapperEl$scrollTo2));
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    var indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  var newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      var targetSlideIndex = void 0;
      if (gridEnabled) {
        var slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.filter(function (slideEl) {
          return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex;
        })[0].column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      var centeredSlides = swiper.params.centeredSlides;

      var slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      var needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (needLoopFix) {
        var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction: direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        var _slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.filter(function (slideEl) {
          return slideEl.getAttribute('data-swiper-slide-index') * 1 === _slideIndex;
        })[0].column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(function () {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var enabled = swiper.enabled,
      params = swiper.params,
      animating = swiper.animating;

  if (!enabled || swiper.destroyed) return swiper;
  var perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(function () {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled,
      animating = swiper.animating;

  if (!enabled || swiper.destroyed) return swiper;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    var prevSnapIndex = void 0;
    snapGrid.forEach(function (snap, snapIndex) {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  var prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(function () {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  if (swiper.destroyed) return;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex = void 0;
  var slideSelector = swiper.isElement ? 'swiper-slide' : '.' + params.slideClass;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
        (0, _utils.n)(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
      (0, _utils.n)(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate(slideRealIndex) {
  var swiper = this;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  var initSlides = function initSlides() {
    var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
    slides.forEach(function (el, index) {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  var addBlankSlides = function addBlankSlides(amountOfSlides) {
    for (var i = 0; i < amountOfSlides; i += 1) {
      var slideEl = swiper.isElement ? (0, _utils.c)('swiper-slide', [params.slideBlankClass]) : (0, _utils.c)('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      var _slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(_slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex: slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next'
  });
}

function loopFix(_temp) {
  var _ref4 = _temp === void 0 ? {} : _temp,
      slideRealIndex = _ref4.slideRealIndex,
      _ref4$slideTo = _ref4.slideTo,
      slideTo = _ref4$slideTo === undefined ? true : _ref4$slideTo,
      direction = _ref4.direction,
      setTranslate = _ref4.setTranslate,
      activeSlideIndex = _ref4.activeSlideIndex,
      byController = _ref4.byController,
      byMousewheel = _ref4.byMousewheel;

  var swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  var slides = swiper.slides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      slidesEl = swiper.slidesEl,
      params = swiper.params;
  var centeredSlides = params.centeredSlides;

  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  var slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  var loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides) {
    (0, _utils.t)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    (0, _utils.t)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  var prependSlidesIndexes = [];
  var appendSlidesIndexes = [];
  var activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.filter(function (el) {
      return el.classList.contains(params.slideActiveClass);
    })[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  var isNext = direction === 'next' || !direction;
  var isPrev = direction === 'prev' || !direction;
  var slidesPrepended = 0;
  var slidesAppended = 0;
  var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      var index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        var colIndexToPrepend = cols - index - 1;
        for (var _i5 = slides.length - 1; _i5 >= 0; _i5 -= 1) {
          if (slides[_i5].column === colIndexToPrepend) prependSlidesIndexes.push(_i5);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);

    var _loop = function _loop(_i6) {
      var index = _i6 - Math.floor(_i6 / cols) * cols;
      if (gridEnabled) {
        slides.forEach(function (slide, slideIndex) {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    };

    for (var _i6 = 0; _i6 < slidesAppended; _i6 += 1) {
      _loop(_i6);
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(function () {
    swiper.__preventObserver__ = false;
  });
  if (isPrev) {
    prependSlidesIndexes.forEach(function (index) {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(function (index) {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach(function (slide, slideIndex) {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        var currentSlideTranslate = swiper.slidesGrid[activeIndex];
        var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        var diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        var _currentSlideTranslate = swiper.slidesGrid[activeIndex];
        var _newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        var _diff = _newSlideTranslate - _currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - _diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - _diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - _diff;
          }
        }
      } else {
        var _shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - _shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    var loopParams = {
      slideRealIndex: slideRealIndex,
      direction: direction,
      setTranslate: setTranslate,
      activeSlideIndex: activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(function (c) {
        if (!c.destroyed && c.params.loop) c.loopFix(_extends({}, loopParams, {
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        }));
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix(_extends({}, loopParams, {
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      }));
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  var newSlidesOrder = [];
  swiper.slides.forEach(function (slideEl) {
    var index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(function (slideEl) {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(function (slideEl) {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(function () {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  var swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(function () {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === (0, _ssrWindowEsm.g)() || el === (0, _ssrWindowEsm.a)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  var window = (0, _ssrWindowEsm.a)();
  var params = swiper.params;

  var edgeSwipeDetection = params.edgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  var swiper = this;
  var document = (0, _ssrWindowEsm.g)();
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  var targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!swiper.wrapperEl.contains(targetEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  var eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0, _utils.d)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  var preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) {
    document.activeElement.blur();
  }
  var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = (0, _ssrWindowEsm.g)();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    var id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  var targetTouch = void 0;
  if (e.type === 'touchmove') {
    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
      return t.identifier === data.touchId;
    })[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  var pageX = targetTouch.pageX;
  var pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0, _utils.d)();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    var touchAngle = void 0;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  var diff = swiper.isHorizontal() ? diffX : diffY;
  var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  var prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  var isLoop = swiper.params.loop && !params.cssMode;
  var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      var evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  var loopFixed = void 0;
  new Date().getTime();
  if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var targetTouch = void 0;
  var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
      return t.identifier === data.touchId;
    })[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    var proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      slidesGrid = swiper.slidesGrid,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = (0, _utils.d)();
  var timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    var pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = (0, _utils.d)();
  (0, _utils.n)(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos = void 0;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos: currentPos
    });
    return;
  }

  // Find current slide
  var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  var rewindFirstIndex = null;
  var rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;

  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid;

  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  var isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(function () {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;

  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  var swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  var swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

var events = function events(swiper, method) {
  var document = (0, _ssrWindowEsm.g)();
  var params = swiper.params,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device;

  var capture = !!params.nested;
  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  var swiperMethod = method;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture: capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture: capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture: capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  var swiper = this;
  var params = swiper.params;

  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  var swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

var isGridEnabled = function isGridEnabled(swiper, params) {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  var swiper = this;
  var realIndex = swiper.realIndex,
      initialized = swiper.initialized,
      params = swiper.params,
      el = swiper.el;

  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Get breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = isGridEnabled(swiper, params);
  var isMultiRow = isGridEnabled(swiper, breakpointParams);
  var wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(params.containerModifierClass + 'grid', params.containerModifierClass + 'grid-column');
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(params.containerModifierClass + 'grid');
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(params.containerModifierClass + 'grid-column');
    }
    swiper.emitContainerClasses();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(function (prop) {
    if (typeof breakpointParams[prop] === 'undefined') return;
    var wasModuleEnabled = params[prop] && params[prop].enabled;
    var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  var wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  (0, _utils.u)(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  var hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = (0, _ssrWindowEsm.a)();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }
    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia('(min-width: ' + value + 'px)').matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  var _el$classList;

  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      el = swiper.el,
      device = swiper.device;
  // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push.apply(classNames, _toConsumableArray(suffixes));
  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var _el$classList2;

  var swiper = this;
  var el = swiper.el,
      classNames = swiper.classNames;

  (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked,
      params = swiper.params;
  var slidesOffsetBefore = params.slidesOffsetBefore;

  if (slidesOffsetBefore) {
    var lastSlideIndex = swiper.slides.length - 1;
    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    var moduleParamName = Object.keys(obj)[0];
    var moduleParams = obj[moduleParamName];
    if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) {
      (0, _utils.u)(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      (0, _utils.u)(allModulesParams, obj);
      return;
    }
    if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    (0, _utils.u)(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
var prototypes = {
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  events: events$1,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes
};
var extendedDefaults = {};

var Swiper = function () {
  function Swiper() {
    _classCallCheck(this, Swiper);

    var el = void 0;
    var params = void 0;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};
    params = (0, _utils.u)({}, params);
    if (el && !params.el) params.el = el;
    var document = (0, _ssrWindowEsm.g)();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      var swipers = [];
      document.querySelectorAll(params.el).forEach(function (containerEl) {
        var newParams = (0, _utils.u)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [].concat(_toConsumableArray(swiper.__modules__));
    if (params.modules && Array.isArray(params.modules)) {
      var _swiper$modules;

      (_swiper$modules = swiper.modules).push.apply(_swiper$modules, _toConsumableArray(params.modules));
    }
    var allModulesParams = {};
    swiper.modules.forEach(function (mod) {
      mod({
        params: params,
        swiper: swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    var swiperParams = (0, _utils.u)({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = (0, _utils.u)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0, _utils.u)({}, swiper.params);
    swiper.passedParams = (0, _utils.u)({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment: function cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
      },

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }

  _createClass(Swiper, [{
    key: 'getDirectionLabel',
    value: function getDirectionLabel(property) {
      if (this.isHorizontal()) {
        return property;
      }
      // prettier-ignore
      return {
        'width': 'height',
        'margin-top': 'margin-left',
        'margin-bottom ': 'margin-right',
        'margin-left': 'margin-top',
        'margin-right': 'margin-bottom',
        'padding-left': 'padding-top',
        'padding-right': 'padding-bottom',
        'marginRight': 'marginBottom'
      }[property];
    }
  }, {
    key: 'getSlideIndex',
    value: function getSlideIndex(slideEl) {
      var slidesEl = this.slidesEl,
          params = this.params;

      var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
      var firstSlideIndex = (0, _utils.g)(slides[0]);
      return (0, _utils.g)(slideEl) - firstSlideIndex;
    }
  }, {
    key: 'getSlideIndexByData',
    value: function getSlideIndexByData(index) {
      return this.getSlideIndex(this.slides.filter(function (slideEl) {
        return slideEl.getAttribute('data-swiper-slide-index') * 1 === index;
      })[0]);
    }
  }, {
    key: 'recalcSlides',
    value: function recalcSlides() {
      var swiper = this;
      var slidesEl = swiper.slidesEl,
          params = swiper.params;

      swiper.slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
    }
  }, {
    key: 'enable',
    value: function enable() {
      var swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit('enable');
    }
  }, {
    key: 'disable',
    value: function disable() {
      var swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit('disable');
    }
  }, {
    key: 'setProgress',
    value: function setProgress(progress, speed) {
      var swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      var min = swiper.minTranslate();
      var max = swiper.maxTranslate();
      var current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }, {
    key: 'emitContainerClasses',
    value: function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var cls = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', cls.join(' '));
    }
  }, {
    key: 'getSlideClasses',
    value: function getSlideClasses(slideEl) {
      var swiper = this;
      if (swiper.destroyed) return '';
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    }
  }, {
    key: 'emitSlidesClasses',
    value: function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var updates = [];
      swiper.slides.forEach(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl: slideEl,
          classNames: classNames
        });
        swiper.emit('_slideClass', slideEl, classNames);
      });
      swiper.emit('_slideClasses', updates);
    }
  }, {
    key: 'slidesPerViewDynamic',
    value: function slidesPerViewDynamic(view, exact) {
      if (view === void 0) {
        view = 'current';
      }
      if (exact === void 0) {
        exact = false;
      }
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          slidesSizesGrid = swiper.slidesSizesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;

      var spv = 1;
      if (typeof params.slidesPerView === 'number') return params.slidesPerView;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
        var breakLoop = void 0;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += Math.ceil(slides[i].swiperSlideSize);
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
          if (slides[_i7] && !breakLoop) {
            slideSize += slides[_i7].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        // eslint-disable-next-line
        if (view === 'current') {
          for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
            var slideInView = exact ? slidesGrid[_i8] + slidesSizesGrid[_i8] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          // previous
          for (var _i9 = activeIndex - 1; _i9 >= 0; _i9 -= 1) {
            var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i9] < swiperSize;
            if (_slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
  }, {
    key: 'update',
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params;
      // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]'))).forEach(function (imageEl) {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        }
      });
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated = void 0;
      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
        setTranslate();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
          var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
          translated = swiper.slideTo(slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: 'changeDirection',
    value: function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }
      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }
      swiper.el.classList.remove('' + swiper.params.containerModifierClass + currentDirection);
      swiper.el.classList.add('' + swiper.params.containerModifierClass + newDirection);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.forEach(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    }
  }, {
    key: 'changeLanguageDirection',
    value: function changeLanguageDirection(direction) {
      var swiper = this;
      if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
      swiper.rtl = direction === 'rtl';
      swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
      if (swiper.rtl) {
        swiper.el.classList.add(swiper.params.containerModifierClass + 'rtl');
        swiper.el.dir = 'rtl';
      } else {
        swiper.el.classList.remove(swiper.params.containerModifierClass + 'rtl');
        swiper.el.dir = 'ltr';
      }
      swiper.update();
    }
  }, {
    key: 'mount',
    value: function mount(element) {
      var swiper = this;
      if (swiper.mounted) return true;

      // Find el
      var el = element || swiper.params.el;
      if (typeof el === 'string') {
        el = document.querySelector(el);
      }
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
        swiper.isElement = true;
      }
      var getWrapperSelector = function getWrapperSelector() {
        return '.' + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
      };
      var getWrapper = function getWrapper() {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          var res = el.shadowRoot.querySelector(getWrapperSelector());
          // Children needs to return slot items
          return res;
        }
        return (0, _utils.e)(el, getWrapperSelector())[0];
      };
      // Find Wrapper
      var wrapperEl = getWrapper();
      if (!wrapperEl && swiper.params.createElements) {
        wrapperEl = (0, _utils.c)('div', swiper.params.wrapperClass);
        el.append(wrapperEl);
        (0, _utils.e)(el, '.' + swiper.params.slideClass).forEach(function (slideEl) {
          wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        el: el,
        wrapperEl: wrapperEl,
        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
        hostEl: swiper.isElement ? el.parentNode.host : el,
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl'),
        wrongRTL: (0, _utils.o)(wrapperEl, 'display') === '-webkit-box'
      });
      return true;
    }
  }, {
    key: 'init',
    value: function init(el) {
      var swiper = this;
      if (swiper.initialized) return swiper;
      var mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }

      // Slide To Initial Slide
      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Attach events
      swiper.attachEvents();
      var lazyElements = [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]')));
      if (swiper.isElement) {
        lazyElements.push.apply(lazyElements, _toConsumableArray(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
      }
      lazyElements.forEach(function (imageEl) {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        } else {
          imageEl.addEventListener('load', function (e) {
            processLazyPreloader(swiper, e.target);
          });
        }
      });
      preload(swiper);

      // Init Flag
      swiper.initialized = true;
      preload(swiper);

      // Emit
      swiper.emit('init');
      swiper.emit('afterInit');
      return swiper;
    }
  }, {
    key: 'destroy',
    value: function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }
      if (cleanStyles === void 0) {
        cleanStyles = true;
      }
      var swiper = this;
      var params = swiper.params,
          el = swiper.el,
          wrapperEl = swiper.wrapperEl,
          slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }
      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        el.removeAttribute('style');
        wrapperEl.removeAttribute('style');
        if (slides && slides.length) {
          slides.forEach(function (slideEl) {
            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
            slideEl.removeAttribute('style');
            slideEl.removeAttribute('data-swiper-slide-index');
          });
        }
      }
      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        swiper.el.swiper = null;
        (0, _utils.v)(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
  }], [{
    key: 'extendDefaults',
    value: function extendDefaults(newDefaults) {
      (0, _utils.u)(extendedDefaults, newDefaults);
    }
  }, {
    key: 'installModule',
    value: function installModule(mod) {
      if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
      var modules = Swiper.prototype.__modules__;
      if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
  }, {
    key: 'use',
    value: function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }
      Swiper.installModule(module);
      return Swiper;
    }
  }, {
    key: 'extendedDefaults',
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: 'defaults',
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);

exports.S = Swiper;
exports.d = defaults;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v = exports.u = exports.t = exports.s = exports.r = exports.q = exports.p = exports.o = exports.n = exports.m = exports.l = exports.k = exports.j = exports.i = exports.h = exports.g = exports.f = exports.e = exports.d = exports.c = exports.b = exports.a = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ssrWindowEsm = __webpack_require__(3);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function classesToTokens(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return classes.trim().split(' ').filter(function (c) {
    return !!c.trim();
  });
}

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle(el) {
  var window = (0, _ssrWindowEsm.a)();
  var style = void 0;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }
  var window = (0, _ssrWindowEsm.a)();
  var matrix = void 0;
  var curTransform = void 0;
  var transformMatrix = void 0;
  var curStyle = getComputedStyle(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });
      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  var swiper = _ref.swiper,
      targetPosition = _ref.targetPosition,
      side = _ref.side;

  var window = (0, _ssrWindowEsm.a)();
  var startPosition = -swiper.translate;
  var startTime = null;
  var time = void 0;
  var duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  var dir = targetPosition > startPosition ? 'next' : 'prev';
  var isOutOfBound = function isOutOfBound(current, target) {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  var animate = function animate() {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(function () {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = '';
  }
  return [].concat(_toConsumableArray(element.children)).filter(function (el) {
    return el.matches(selector);
  });
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes) {
  var _el$classList;

  if (classes === void 0) {
    classes = [];
  }
  var el = document.createElement(tag);
  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementOffset(el) {
  var window = (0, _ssrWindowEsm.a)();
  var document = (0, _ssrWindowEsm.g)();
  var box = el.getBoundingClientRect();
  var body = document.body;
  var clientTop = el.clientTop || body.clientTop || 0;
  var clientLeft = el.clientLeft || body.clientLeft || 0;
  var scrollTop = el === window ? window.scrollY : el.scrollTop;
  var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  var prevEls = [];
  while (el.previousElementSibling) {
    var prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  var nextEls = [];
  while (el.nextElementSibling) {
    var next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  var window = (0, _ssrWindowEsm.a)();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  var child = el;
  var i = void 0;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  var parents = []; // eslint-disable-line
  var parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  var window = (0, _ssrWindowEsm.a)();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(function (e) {
    return !!e;
  });
}

exports.a = elementParents;
exports.b = elementOffset;
exports.c = createElement;
exports.d = now;
exports.e = elementChildren;
exports.f = elementOuterSize;
exports.g = elementIndex;
exports.h = classesToTokens;
exports.i = getTranslate;
exports.j = elementTransitionEnd;
exports.k = isObject;
exports.l = getSlideTransformEl;
exports.m = makeElementsArray;
exports.n = nextTick;
exports.o = elementStyle;
exports.p = elementNextAll;
exports.q = elementPrevAll;
exports.r = animateCSSModeScroll;
exports.s = setCSSProperty;
exports.t = showWarning;
exports.u = extend;
exports.v = deleteProps;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiperCore = __webpack_require__(13);

Object.defineProperty(exports, 'Swiper', {
  enumerable: true,
  get: function get() {
    return _swiperCore.S;
  }
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _swiperCore.S;
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rpAnalytics = __webpack_require__(2);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

var _swiper = __webpack_require__(15);

var _swiper2 = _interopRequireDefault(_swiper);

var _chunkArray = __webpack_require__(24);

var _orderByPosition = __webpack_require__(1);

var _outsideClickHandler = __webpack_require__(26);

var _constants = __webpack_require__(0);

var _constants2 = __webpack_require__(17);

var _filterBookmakers = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OPEN = _constants.BOOKMAKER_STATUS.OPEN;
var EXCLUSIVE = _constants.BOOKMAKER_OFFER_TYPE.EXCLUSIVE;


var initBookmakersExclusiveOffersPanel = function initBookmakersExclusiveOffersPanel(desktopBookmakers, mobileBookmakers) {
    var bookmakers = _constants.isMobile ? mobileBookmakers : desktopBookmakers;
    var filteredBookmakers = (0, _filterBookmakers.getBookmakersToShow)(bookmakers, EXCLUSIVE);
    /**
     * bookmakerPosition is the index of displayed bookmaker card
     * position is the position from API response and may be different from bookmakerPosition
     * TODO: refactor and choose which prop is needed
     */
    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers).map(function (bookmaker, index) {
        return _extends({}, bookmaker, {
            bookmakerPosition: index + 1
        });
    });

    // Carousel wrapper will not be present if carousel_visibility is set to false - JP-9212
    var containers = document.querySelectorAll(_constants2.selectors.mainContainer);

    if (!bookmakers.length && containers.length) {
        containers.forEach(function (container) {
            container.classList.add(_constants2.classes.mainContainerHide);
        });

        return;
    }

    var swiperWrapper = document.createElement('div');
    var chunkedBookmakers = (0, _chunkArray.chunkArray)(orderedBookmakers, 4);

    chunkedBookmakers.forEach(function (chunk) {
        chunk.forEach(function (bookmaker) {
            var bookmakerOffer = bookmaker.altOffer ? bookmaker.altOffer : bookmaker.offer;

            var swiperSlide = document.createElement('div');
            swiperSlide.classList.add(_constants2.classes.slide);
            swiperSlide.classList.add(_constants2.classes.offersContainer);

            var bookmakerElement = document.createElement('div');

            if (bookmaker.takeover_image) {
                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.takeover_image + ')';
                bookmakerElement.style.backgroundSize = 'cover';
            } else if (bookmaker.background_image) {
                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.background_image + ')';
                bookmakerElement.style.backgroundSize = 'cover';
            } else {
                bookmakerElement.style.backgroundColor = bookmaker.colourBranding || '#fff';
            }

            bookmakerElement.classList.add(_constants2.classes.bookmaker);

            if (bookmaker.takeover_image) {
                bookmakerElement.innerHTML = '\n                    <a href=\'' + bookmaker.sign_up_link_1 + '\' target="_blank" \n                    class="bookmakersExclusive__takeoverImageLink bookmakersExclusive__claim-btn"\n                    data-name=\'' + bookmaker.name + '\'\n                    bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                    slide-item-position=\'' + bookmaker.position + '\'\n                    bookmaker-offer=\'null\'\n                    bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                    rel="noreferrer nofollow sponsored"\n                    ></a>';
            } else {
                bookmakerElement.innerHTML = '\n                    <img class="bookmakersExclusive__logo" src="' + bookmaker.bookmaker_logo + '"/>\n                    ' + (bookmaker.offer && '<p class="bookmakersExclusive__offer"\n                            style="color: ' + (bookmaker.textColour || '#000') + '"\n                        >' + bookmaker.offer + '</p>') + '               \n                ' + (bookmaker.tsAndCsRequired === 'true' ? '<button\n                                class="bookmakersExclusive__claim-btn"\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                                slide-item-position=\'' + bookmaker.position + '\'\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                            >\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </button>' : '<a href=\'' + bookmaker.sign_up_link_1 + '\'\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=' + bookmaker.bookmakerPosition + '\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                target="_blank"\n                                rel="noreferrer nofollow sponsored"\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                                class="bookmakersExclusive__claim-btn">\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </a>') + '\n                 <p class="bookmakersExclusive__terms">' + bookmaker.tsAndCs + '</p>\n                ';
            }
            bookmakerElement.setAttribute(_constants2.attributes.slidePerPosition, bookmaker.bookmakerPosition);
            bookmakerElement.setAttribute(_constants2.attributes.requiredTerms, bookmaker.tsAndCsRequired);
            swiperSlide.appendChild(bookmakerElement);
            swiperWrapper.appendChild(swiperSlide);
        });
    });

    var swiperContainer = document.createElement('div');
    swiperContainer.innerHTML = '\n        <div class="bookmakersExclusive__heading">\n            <div class="bookmakersExclusive__headingText">Today\u2019s Top Offers</div>\n            <div class="bookmakersExclusive__subHeading">\n                <p class="bookmakersExclusive__subHeadingText">Exclusive new offers</p>\n                <div class="bookmakersExclusive__subHeadingWrapper">\n                    <p class="bookmakersExclusive__subHeadingTextDragMore">Drag to view more</p>\n                    <a href="/free-bets/" target="_blank" class="bookmakersExclusive__subHeadingTextAllOffers">\n                        All offers\n                        <svg class="ui-icon ui-icon_sizeSmall">\n                            <use xlink:href="#icon-right"/>\n                        </svg>\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class="swiper bookmakersExclusive__swiperContainer">\n            <div class="swiper-wrapper">\n                ' + swiperWrapper.innerHTML + '\n            </div>\n        </div>\n    ';

    document.querySelectorAll(_constants2.selectors.skeleton).forEach(function (skeleton) {
        skeleton.remove();
    });
    var carouselContainers = document.querySelectorAll(_constants2.selectors.carouselContainer);

    var slides = [];

    // Carousel containers will not be present if carousel_visibility is set to false - JP-9212
    if (carouselContainers.length > 0) {
        document.querySelectorAll(_constants2.selectors.carouselContainer).forEach(function (container) {
            // eslint-disable-next-line no-param-reassign
            container.innerHTML = swiperContainer.innerHTML;
        });

        var bookmakersExclusiveContainer = document.querySelector(_constants2.selectors.container);
        slides = bookmakersExclusiveContainer.querySelectorAll('.' + _constants2.classes.offersContainer);

        // eslint-disable-next-line no-unused-vars
        var swiper = new _swiper2.default(bookmakersExclusiveContainer, {
            spaceBetween: 8,
            allowTouchMove: true,
            slidesPerView: 'auto'
        });
    }
    /**
     *
     * @param {Object} data
     */
    var createPopUp = function createPopUp(data) {
        var container = document.querySelector(_constants2.selectors.popUpContainer);
        var popUpWrapper = document.createElement('div');
        popUpWrapper.classList.add(_constants2.classes.popUpWrapper);
        popUpWrapper.setAttribute('' + _constants2.attributes.slidePerPosition, data.position);
        popUpWrapper.dataset.visible = false;
        popUpWrapper.innerHTML = '\n            <div class="bookmakersExclusive__popUp" style="background: ' + (data.colourBranding || '#fff') + '">\n                <img class="bookmakersExclusive__popUpLogo" src="' + data.bookmaker_logo + '"/>\n                ' + (data.offer.length && '<p\n                        class="bookmakersExclusive__popUpTitle"\n                        style="color: ' + (data.textColour || '#000') + '"\n                    >' + data.offer + '</p>') + '\n                <a href=\'' + (data.sign_up_link_1 === '' ? '/' : data.sign_up_link_1) + '\'\n                    style="\n                        background-color: ' + (data.linkColour || '#F01E28') + ';\n                        color: ' + (data.linkTextColour || '#000') + '\n                        "\n                    target="_blank" class="bookmakersExclusive__PopUpClaimBtn"\n                    rel="noreferrer nofollow sponsored">\n                    ' + (window.innerWidth > 989 ? data.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                </a>\n                ' + (data.tsAndCs.length && '<p\n                        class="bookmakersExclusive__popUpTsAndCs"\n                        ' + (!data.colourBranding && 'style="color: #000"') + '\n                    >' + data.tsAndCs + '</p>') + '\n            </div>\n        ';

        container.appendChild(popUpWrapper);
    };

    var bookmakerName = void 0;
    var bookmakerPosition = void 0;
    var bookmakerOffer = void 0;
    var bookmakerTier = void 0;
    var headerTitle = 'Offer’s Carousel';

    var claimButtons = Array.from(document.querySelectorAll(_constants2.selectors.claimButton));
    if (claimButtons.length) {
        claimButtons.forEach(function (button) {
            return button.addEventListener('click', function () {
                bookmakerName = button.getAttribute(_constants2.attributes.dataName);

                bookmakerPosition = Number(button.getAttribute(_constants2.attributes.bookmakerPosition));

                bookmakerOffer = button.getAttribute(_constants2.attributes.bookmakerOffer);
                bookmakerTier = button.getAttribute(_constants2.attributes.bookmakerTier);

                if (button.tagName === 'BUTTON') {
                    var _SegmentIO$trackOffer;

                    SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, OPEN), _SegmentIO$trackOffer));
                } else {
                    var _SegmentIO$trackBookm;

                    SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer === 'null' ? null : bookmakerOffer), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm));
                }
            });
        });
    }

    var bookmakersCards = document.querySelectorAll(_constants2.selectors.offers);

    bookmakersCards.forEach(function (bookmaker) {
        var offersCard = bookmaker.querySelector(_constants2.selectors.offersCard);
        var dataTermsAndConditions = offersCard.getAttribute(_constants2.attributes.requiredTerms);
        var currentOfferData = orderedBookmakers[Number(offersCard.getAttribute(_constants2.attributes.slidePerPosition)) - 1];

        if (dataTermsAndConditions.toLowerCase() === 'true') {
            createPopUp(currentOfferData);
        }
    });

    var button = document.querySelector(_constants2.selectors.allOffersButton);

    // All offers button will not be present if carousel_visibility is set to false - JP-9212
    if (button) {
        button.addEventListener('click', function () {
            SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle));
        });
    }

    var popUpWrappers = document.querySelectorAll(_constants2.selectors.popUpWrapper);

    // Slides will not be present if carousel_visibility is set to false - JP-9212
    if (slides.length > 0) {
        slides.forEach(function (slide) {
            slide.addEventListener('click', function (e) {
                if (e.target.classList.contains(_constants2.classes.termsText)) {
                    var termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);

                    e.target.dataset.termsHidden = !JSON.parse(e.target.dataset.termsHidden);
                    termsExpand.dataset.expanded = !JSON.parse(termsExpand.dataset.expanded);
                } else if (e.target.classList.contains(_constants2.classes.termsHide)) {
                    var termsBtn = slide.querySelector('.' + _constants2.classes.termsText);
                    var _termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);

                    termsBtn.dataset.termsHidden = !JSON.parse(termsBtn.dataset.termsHidden);
                    _termsExpand.dataset.expanded = !JSON.parse(_termsExpand.dataset.expanded);
                } else if (e.target.tagName === 'BUTTON') {
                    var popUp = Array.from(popUpWrappers).find(function (element) {
                        return element.getAttribute(_constants2.attributes.slidePerPosition) === e.target.getAttribute(_constants2.attributes.slidePerPosition);
                    });
                    popUp.dataset.visible = 'true';
                    document.documentElement.classList.add('no-scroll');
                    (0, _outsideClickHandler.handleClickOutside)(_constants2.selectors.popUp, function () {
                        popUp.dataset.visible = false;
                        document.documentElement.classList.remove('no-scroll');
                    });
                }
            });
        });
    }

    popUpWrappers.forEach(function (wrapper) {
        var claimButton = wrapper.querySelector(_constants2.selectors.popUpClaimButton);

        claimButton.addEventListener('click', function () {
            var _SegmentIO$trackBookm2;

            var popUp = document.querySelector('.bookmakersExclusive__popUpWrapper[data-visible="true"]');
            popUp.dataset.visible = false;
            document.documentElement.classList.remove('no-scroll');

            SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm2));
        });
    });
};

exports.default = initBookmakersExclusiveOffersPanel;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var selectors = exports.selectors = Object.freeze({
    carouselContainer: '.carousel-container',
    container: '.bookmakersExclusive__swiperContainer',
    expandWrapper: '.bookmakersExclusive__terms-expand-wrapper',
    skeleton: '.bookmakersExclusive__skeleton',
    claimButton: '.bookmakersExclusive__claim-btn',
    takeoverImageLink: '.bookmakersExclusive__takeoverImageLink',
    allOffersButton: '.bookmakersExclusive__subHeadingTextAllOffers',
    offers: '.bookmakersExclusive__offersContainer',
    offersCard: '.bookmakersExclusive__bookmaker',
    popUpContainer: '.bookmakersExclusive__popUpContainer',
    popUpWrapper: '.bookmakersExclusive__popUpWrapper',
    popUpClaimButton: '.bookmakersExclusive__PopUpClaimBtn',
    headerTitle: '.bookmakersExclusive__headingText',
    popUp: '.bookmakersExclusive__popUp',
    mainContainer: '.js-carouselWrapper'
});

var classes = exports.classes = Object.freeze({
    termsText: 'bookmakersExclusive__terms-text',
    termsHide: 'bookmakersExclusive__terms-hide',
    offersContainer: 'bookmakersExclusive__offersContainer',
    bookmaker: 'bookmakersExclusive__bookmaker',
    slide: 'swiper-slide',
    popUpWrapper: 'bookmakersExclusive__popUpWrapper',
    mainContainerHide: 'js-carouselWrapper--hide'
});

var attributes = exports.attributes = Object.freeze({
    dataName: 'data-name',
    bookmakerPosition: 'bookmaker-position',
    bookmakerOffer: 'bookmaker-offer',
    requiredTerms: 'required-terms-and-conditions',
    slidePerPosition: 'slide-item-position',
    bookmakerTier: 'bookmaker-tier'
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _orderByPosition = __webpack_require__(1);

var initTierTwoBookmakersPanel = function initTierTwoBookmakersPanel(bookmakers) {
    var filteredBookmakers = bookmakers.filter(function (bookmaker) {
        return bookmaker.name && bookmaker.includeInTier2Panel;
    });
    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers).slice(0, 12);

    var bookmakersContainer = document.createElement('div');
    bookmakersContainer.classList.add('bookmakersTierTwo__offersContainer');

    orderedBookmakers.forEach(function (bookmaker, index) {
        var bookmakerOffer = bookmaker.altOffer || bookmaker.offer;

        var bookmakerElement = document.createElement('a');
        bookmakerElement.setAttribute('bookmaker-position', index + 1);
        bookmakerElement.setAttribute('bookmaker-name', bookmaker.name);
        bookmakerElement.setAttribute('href', bookmaker.signUpLink1);
        bookmakerElement.setAttribute('bookmaker-offer', bookmakerOffer);
        bookmakerElement.setAttribute('target', '_blank');
        bookmakerElement.setAttribute('rel', 'noreferrer nofollow sponsored');
        bookmakerElement.classList.add('bookmakersTierTwo__bookmaker');

        bookmakerElement.innerHTML = '\n            <div class="bookmakersTierTwo__top__row">\n                <img class="bookmakersTierTwo__logo" src="' + bookmaker.bookmakerLogo + '"/>\n                <p class="bookmakersTierTwo__offer"\n                    style="color: ' + (bookmaker.textColour || '#fff') + '"\n                >\n                    ' + (bookmaker.offer ? bookmaker.offer : '') + '\n                </p>\n            </div>\n            ' + (bookmaker.tsAndCs ? '\n            <p class="bookmakersTierTwo__terms"\n               style="color: ' + (bookmaker.textColour || '#fff') + '">\n                ' + bookmaker.tsAndCs + '\n            </p>\n            ' : '') + '\n        ';
        bookmakerElement.style.backgroundColor = bookmaker.colourBranding;

        bookmakersContainer.appendChild(bookmakerElement);
    });

    var container = document.createElement('div');
    container.innerHTML = '\n        <div class="bookmakersTierTwo__heading">\n            <div class="bookmakersTierTwo__headingContainer">\n                <div class="bookmakersTierTwo__subHeading__row">\n                    <div class="bookmakersTierTwo__headingText">MORE OFFERS</div>\n                    <a href="/free-bets/" target="_blank" class="bookmakersTierTwo__subHeadingTextAllOffers">\n                        All offers\n                        <svg class="ui-icon ui-icon_sizeSmall">\n                            <use xlink:href="#icon-right"/>\n                        </svg>\n                    </a>\n                </div>\n            </div>\n        </div>\n    ';

    container.appendChild(bookmakersContainer);
    var footer = document.createElement('p');
    footer.classList.add('bookmakersTierTwo__BookmakerOffersContentTcApplyTierTwo');
    footer.textContent = 'T&Cs apply. 18+ GambleAware.org';
    container.appendChild(footer);

    document.querySelectorAll('#bookmakersTierTwoSkeleton').forEach(function (s) {
        return s.remove();
    });

    document.querySelectorAll('#bookmakersTierTwoSwiper').forEach(function (div) {
        var clone = container.cloneNode(true);
        div.appendChild(clone);

        if (!orderedBookmakers.length) {
            div.parentNode.classList.add('bookmakersTierTwo--hidden');
        }
    });
};

exports.default = initTierTwoBookmakersPanel;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint import/prefer-default-export: "off" */
var selectors = exports.selectors = Object.freeze({
    bookmakersListWeb: '.rh-bookmakers__list--web'
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _constants2 = __webpack_require__(5);

var _constants3 = __webpack_require__(19);

var renderPromotedTierTwoBookmakers = function renderPromotedTierTwoBookmakers(desktopOffers, mobileOffers) {
    var defaultLinkText = 'Claim this offer';
    var displayNone = 'display:none;';

    desktopOffers.forEach(function (_ref) {
        var altOffer = _ref.altOffer,
            discBookmakerLogo = _ref.discBookmakerLogo,
            bookmakerLogo = _ref.bookmakerLogo,
            bookmakerLogoLargeUrl = _ref.bookmakerLogoLargeUrl,
            colourBranding = _ref.colourBranding,
            linkText = _ref.linkText,
            name = _ref.name,
            offer = _ref.offer,
            signUpLink1 = _ref.signUpLink1,
            tsAndCs = _ref.tsAndCs;

        var lowercaseName = name.toLowerCase().replace(' ', '');
        var bookmakerOffer = altOffer || offer;
        // bookmakerLogoSquare is in the response for tier2

        // desktop promoted T2/T3 offers
        var desktopOffer = document.createElement('li');
        desktopOffer.classList.add('rh-bookmaker');
        desktopOffer.classList.add('rh-bookmaker--' + lowercaseName);
        desktopOffer.setAttribute('data-name', name);
        desktopOffer.setAttribute('data-index', lowercaseName);
        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        desktopOffer.setAttribute('bookmaker-color', colourBranding);
        desktopOffer.setAttribute('promoted-bookmaker', 'true');
        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        // For local testing -> square logo fetch from Janus
        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />

        var innerHTMLDesktop = '\n                <div\n                    class="rh-bookmaker__header rh-bookmaker__header--' + lowercaseName + '"\n                    style="background-color: ' + colourBranding + ';"\n                >\n                <img\n                        src=' + bookmakerLogo + '\n                        width={70}\n                        height={32}\n                        alt=' + name + '\n                        class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + ' rh-bookmaker__logo--open"\n                    />\n                    <a\n                           href=' + signUpLink1 + '\n                           target="_blank"\n                           class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker__btn_claim_header"\n                           style="' + (!_constants.isDesktopBeakpoint ? displayNone : '') + '"\n                           data-name=' + name + '\n                           data-index=' + lowercaseName + '\n                           data-test-selector="link-bm-' + lowercaseName + '"\n                           bookmaker-offer="' + bookmakerOffer + '"\n                           rel="noreferrer nofollow sponsored"\n                        >\n                        ' + _constants2.BUTTON_TEXT + '\n                    </a>\n                </div>\n\n                <div class="rh-bookmaker-offer">\n                    <p class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</p>\n                    <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n                </div>\n            </div>\n    ';

        var bookmakerContainersDesktop = document.querySelectorAll(_constants3.selectors.bookmakersListWeb);
        Array.from(bookmakerContainersDesktop).forEach(function (container) {
            desktopOffer.innerHTML = innerHTMLDesktop;
            container.appendChild(desktopOffer.cloneNode(true));
        });

        // tablet promoted T2/T3 offers
        var tabletOffer = document.createElement('li');
        tabletOffer.classList.add('rh-bookmaker');
        tabletOffer.classList.add('rh-bookmaker--' + lowercaseName);
        tabletOffer.setAttribute('data-name', name);
        tabletOffer.setAttribute('data-index', lowercaseName);
        tabletOffer.setAttribute('data-type', 'discOffer');
        tabletOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        tabletOffer.setAttribute('bookmaker-color', colourBranding);
        tabletOffer.setAttribute('promoted-bookmaker', 'true');
        tabletOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var innerHTMLTablet = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                width=100\n                height=55\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + signUpLink1 + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';

        var bookmakerContainersTablet = document.querySelectorAll('.rh-bookmakers__list--tablet');
        Array.from(bookmakerContainersTablet).forEach(function (container) {
            tabletOffer.innerHTML = innerHTMLTablet;
            container.appendChild(tabletOffer.cloneNode(true));
        });
    });

    mobileOffers.forEach(function (_ref2) {
        var altOffer = _ref2.altOffer,
            offer = _ref2.offer,
            discBookmakerLogo = _ref2.discBookmakerLogo,
            tsAndCs = _ref2.tsAndCs,
            discLinkURL = _ref2.discLinkURL,
            bookmakerLogoLargeUrl = _ref2.bookmakerLogoLargeUrl,
            colourBranding = _ref2.colourBranding,
            linkText = _ref2.linkText,
            name = _ref2.name;

        var lowercaseName = name.toLowerCase().replace(' ', '');
        var bookmakerOffer = altOffer || offer;

        // mobile promoted T2/T3 offers
        var mobileOffer = document.createElement('li');
        mobileOffer.classList.add('rh-bookmaker');
        mobileOffer.classList.add('rh-bookmaker--' + lowercaseName);
        mobileOffer.setAttribute('data-name', name);
        mobileOffer.setAttribute('data-index', lowercaseName);
        mobileOffer.setAttribute('data-type', 'discOffer');
        mobileOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        mobileOffer.setAttribute('bookmaker-color', colourBranding);
        mobileOffer.setAttribute('promoted-bookmaker', 'true');
        mobileOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var innerHTMLMobile = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + discLinkURL + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';

        var bookmakerContainersMobile = document.querySelectorAll('.rh-bookmakers__list--mobile');
        Array.from(bookmakerContainersMobile).forEach(function (container) {
            mobileOffer.innerHTML = innerHTMLMobile;
            container.appendChild(mobileOffer.cloneNode(true));
        });
    });
}; /* eslint-disable camelcase */
exports.default = renderPromotedTierTwoBookmakers;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var selectors = exports.selectors = Object.freeze({
    bookmakersListWeb: '.rh-bookmakers__list--web'
});

var classes = exports.classes = Object.freeze({
    bookmakerOpen: 'rh-bookmaker--open'
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _filterBookmakers = __webpack_require__(6);

var _constants2 = __webpack_require__(5);

var _constants3 = __webpack_require__(21);

/* eslint-disable camelcase, arrow-parens, no-multi-spaces */
var TIER_ONE = _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE;

// tier 1

var keys = {
    williamhill: 'williamHill',
    raceBets: 'raceBets'
};

var isValidTopOffer = function isValidTopOffer(publishTime, archiveTime) {
    var publishTimeObj = new Date(publishTime);
    var archiveTimeObj = new Date(archiveTime);
    if (isNaN(archiveTimeObj) || isNaN(publishTimeObj)) {
        return false;
    }
    var currentTime = new Date();
    if (currentTime < publishTimeObj || currentTime > archiveTimeObj) {
        return false;
    }
    return true;
};

var discOfferRender = function discOfferRender(offers, device) {
    offers.forEach(function (_ref) {
        var altOffer = _ref.altOffer,
            linkText = _ref.linkText,
            name = _ref.name,
            displayName = _ref.displayName,
            offer = _ref.offer,
            discLinkURL = _ref.discLinkURL,
            discOfferHeadline = _ref.discOfferHeadline,
            signUpLink3 = _ref.signUpLink3,
            tsAndCs = _ref.tsAndCs,
            topOfferPublishTime = _ref.topOfferPublishTime,
            topOfferArchiveTime = _ref.topOfferArchiveTime;

        var lowercaseName = name.toLowerCase();
        var key = keys[lowercaseName] || lowercaseName;
        var bookmakerOffer = altOffer || offer;

        var discOffer = document.createElement('li');
        discOffer.classList.add('rh-bookmaker');
        discOffer.classList.add('rh-bookmaker--' + key);
        discOffer.setAttribute('data-name', displayName);
        discOffer.setAttribute('data-type', 'discOffer');
        discOffer.setAttribute('data-index', key);
        discOffer.setAttribute('data-test-selector', 'link-bm-' + key);
        discOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
        discOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var discOfferInnerHTML = '\n            <div class="rh-bookmaker__header">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + '">\n                    <use xlink:href="#logo-disc-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + key + '">\n                <svg class="rh-bookmaker__logo__text rh-logo--' + key + '">\n                    <use xlink:href="#logo-text-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker-offer__headline">' + (_constants.isMobile ? discOfferHeadline : bookmakerOffer) + '</div>\n                <a href="' + (_constants.isMobile ? discLinkURL : signUpLink3) + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + key + '"\n                    data-test-selector="link-bm-' + key + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + linkText + '\n                </a>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n            </div>\n        ';

        var discContainers = document.querySelectorAll('.rh-bookmakers__list--' + device);
        Array.from(discContainers).forEach(function (container) {
            discOffer.innerHTML = discOfferInnerHTML;
            container.appendChild(discOffer.cloneNode(true));
        });
    });
};

var renderTierOneBookmakers = function renderTierOneBookmakers(desktopOffers, mobileOffers, freeBetsOffers) {
    var displayNone = 'display:none;';

    // NOTE: [JP-9948] Filter tierOne after bookmaker quiz or recent logged bookmaker account
    var filteredDesktopOffers = (0, _filterBookmakers.getBookmakersToShow)(desktopOffers, TIER_ONE);
    var filteredMobileOffers = (0, _filterBookmakers.getBookmakersToShow)(mobileOffers, TIER_ONE);

    filteredDesktopOffers.forEach(function (_ref2) {
        var altOffer = _ref2.altOffer,
            name = _ref2.name,
            displayName = _ref2.displayName,
            offer = _ref2.offer,
            signUpLink3 = _ref2.signUpLink3,
            tsAndCs = _ref2.tsAndCs,
            topOfferPublishTime = _ref2.topOfferPublishTime,
            topOfferArchiveTime = _ref2.topOfferArchiveTime;

        var lowercaseName = name.toLowerCase();
        var key = keys[lowercaseName] || lowercaseName;
        var isSkybet = lowercaseName === 'skybet';
        var bookmakerOffer = altOffer || offer;
        var desktopOffer = document.createElement('li');
        desktopOffer.classList.add('rh-bookmaker');
        desktopOffer.classList.add('rh-bookmaker--' + key);
        desktopOffer.setAttribute('data-name', displayName);
        desktopOffer.setAttribute('data-index', key);
        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + key);
        desktopOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        // For local testing -> square logo fetch from Janus
        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />
        var innerHTMLDesktop = '\n            <div class="rh-bookmaker__header rh-bookmaker__header--' + key + '">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + ' rh-bookmaker__logo--open" style="' + (isSkybet ? displayNone : '') + '">\n                    <use xlink:href="#logo-' + key + '"/>\n                </svg>\n                \n                <div class="rh-bookmaker__logo rh-bookmaker__logo--skybet rh-logo--skybet rh-bookmaker__logo--open" style="' + (!isSkybet ? displayNone : '') + '">\n                </div>\n\n                <div class="top-offer-label">TOP OFFER</div>\n                <a href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + lowercaseName + '" \n                    data-test-selector="link-bm-' + lowercaseName + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + _constants2.BUTTON_TEXT + '\n                </a>\n            </div>\n            <div class="rh-bookmaker-offer">\n                <div class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</div>\n                <a href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics rh-bookmaker-offer__claim-btn--top-offer"\n                    data-name="' + name + '"\n                    data-index="' + lowercaseName + '" \n                    data-test-selector="link-bm-' + lowercaseName + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + _constants2.BUTTON_TEXT + '\n                </a>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n            </div>';

        var bookmakerContainersDesktop = document.querySelectorAll(_constants3.selectors.bookmakersListWeb);
        Array.from(bookmakerContainersDesktop).forEach(function (container) {
            desktopOffer.innerHTML = innerHTMLDesktop;
            container.appendChild(desktopOffer.cloneNode(true));
            container.classList.add(_constants3.classes.bookmakerOpen);
        });
    });

    discOfferRender(filteredDesktopOffers, 'tablet');
    discOfferRender(filteredMobileOffers, 'mobile');

    // Free bets

    var freeBets = document.createElement('a');
    freeBets.classList.add('freeBets__Anchor');
    freeBets.setAttribute('href', '/free-bets/');
    freeBets.setAttribute('target', '_blank');

    // note: icon for expanded offers on everything except bet365

    var freeBetsHTML = '\n        <div class="freeBets__ItemContainer">\n            <div class="freeBets__LogoContainer">\n                <span class="freeBets__Logo">' + freeBetsOffers.name + '</span>\n            </div>\n            <span class="freeBets__Title">' + freeBetsOffers.offer + '</span>\n\n            <img src="/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />\n        </div>';

    var freeBetsContainer = document.querySelectorAll('.rh-freeBets__Container');
    Array.from(freeBetsContainer).forEach(function (container) {
        freeBets.innerHTML = freeBetsHTML;
        container.appendChild(freeBets.cloneNode(true));
    });
};

exports.default = renderTierOneBookmakers;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpAnalytics = __webpack_require__(2);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

__webpack_require__(12);

var _fetchBookmakersTierTwo = __webpack_require__(10);

var _fetchBookmakersTierTwo2 = _interopRequireDefault(_fetchBookmakersTierTwo);

var _fetchBookmakerExclusiveOffers = __webpack_require__(7);

var _fetchBookmakerExclusiveOffers2 = _interopRequireDefault(_fetchBookmakerExclusiveOffers);

var _constants = __webpack_require__(0);

var _getBookmakersName = __webpack_require__(11);

var _fetchBookmakersTierOne = __webpack_require__(9);

var _fetchBookmakersTierOne2 = _interopRequireDefault(_fetchBookmakersTierOne);

var _fetchBookmakersMixedTier = __webpack_require__(8);

var _fetchBookmakersMixedTier2 = _interopRequireDefault(_fetchBookmakersMixedTier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
/* eslint-disable no-param-reassign */


var OPEN = _constants.BOOKMAKER_STATUS.OPEN,
    CLOSE = _constants.BOOKMAKER_STATUS.CLOSE;
var MORE_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.MORE_OFFERS_TITLE,
    TODAYS_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE,
    TODAYS_OFFERS_TITLE_QUICK_LINK = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE_QUICK_LINK;


var initBookmakerRegPanel = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tierOne, tierTwo, openedBookmakerClass, openedOverlayClass, openedOverlayHeaderClass, overlayActiveClass, selectedBreakpointUi, overlay, overlayHeader, bookmakerListMobile, webOffers, tabletOffers, mobileOffers, offerLists, closeOpenDiscOfferUi;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        closeOpenDiscOfferUi = function closeOpenDiscOfferUi() {
                            var openedBookmakerOffer = document.querySelector('.rh-bookmaker--open');

                            overlay.classList.remove(openedOverlayClass);
                            overlayHeader.classList.remove(openedOverlayHeaderClass);
                            openedBookmakerOffer.classList.remove(openedBookmakerClass);
                            bookmakerListMobile.classList.remove(overlayActiveClass);
                        };

                        tierOne = _constants.tierBookmakers.tierOne, tierTwo = _constants.tierBookmakers.tierTwo;

                        if (!_constants.isRacecardsOrResults) {
                            _context.next = 5;
                            break;
                        }

                        _context.next = 5;
                        return (0, _fetchBookmakerExclusiveOffers2.default)();

                    case 5:
                        _context.next = 7;
                        return (0, _fetchBookmakersTierOne2.default)();

                    case 7:
                        _context.next = 9;
                        return (0, _fetchBookmakersTierTwo2.default)();

                    case 9:
                        _context.next = 11;
                        return (0, _fetchBookmakersMixedTier2.default)();

                    case 11:
                        openedBookmakerClass = 'rh-bookmaker--open';
                        openedOverlayClass = 'rh-bookmakers__overlay--open';
                        openedOverlayHeaderClass = 'overlayWrap--open';
                        overlayActiveClass = 'activeDiscOffersOverlay';
                        selectedBreakpointUi = _constants.isTabletBeakpoint ? '.rh-bookmakers__list--tablet' : '.rh-bookmakers__list--mobile';

                        // GET element after injecting

                        overlay = document.querySelector('.rh-bookmakers__overlay');
                        overlayHeader = document.querySelector('main .overlayWrap');
                        bookmakerListMobile = document.querySelector('.rh-bookmakers ' + selectedBreakpointUi);
                        webOffers = document.querySelectorAll('.rh-bookmakers__list--web');
                        tabletOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--tablet');
                        mobileOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--mobile');
                        offerLists = document.querySelectorAll('.rh-bookmakers__list');


                        offerLists.forEach(function (unorderedList) {
                            var listItems = Array.from(unorderedList.querySelectorAll('li'));

                            var validTopOfferItems = listItems.filter(function (item) {
                                return item.getAttribute('data-valid-topoffer') === 'true';
                            });

                            var invalidTopOfferItems = listItems.filter(function (item) {
                                return item.getAttribute('data-valid-topoffer') === 'false';
                            });

                            var promotedTierTwoItems = listItems.filter(function (item) {
                                return item.getAttribute('promoted-bookmaker') === 'true';
                            });

                            // eslint-disable-next-line no-param-reassign
                            unorderedList.innerHTML = '';

                            [].concat(_toConsumableArray(validTopOfferItems), _toConsumableArray(invalidTopOfferItems), _toConsumableArray(promotedTierTwoItems)).forEach(function (item) {
                                return unorderedList.appendChild(item);
                            });
                        });

                        webOffers.forEach(function (desktopList) {
                            desktopList.children[0].classList.add(openedBookmakerClass);

                            var bookmakerClaimBtns = desktopList.querySelectorAll('.rh-bookmaker-offer__claim-btn');

                            if (bookmakerClaimBtns.length > 0) {
                                bookmakerClaimBtns.forEach(function (claimBtn, index) {
                                    if (index === 0) claimBtn.classList.add('rh-bookmaker-offer__claim-btn--hidden');
                                    if (index === 1) claimBtn.classList.add('rh-bookmaker-offer__claim-btn--visible');
                                });
                            }

                            // Add the position attribute to each offer
                            desktopList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });

                        // Add the position attribute to each offer
                        Array.from(tabletOffers).forEach(function (tabletList) {
                            return tabletList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });
                        Array.from(mobileOffers).forEach(function (mobileList) {
                            return mobileList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });

                        if (_constants.isMobile) {
                            Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
                                return webBookmakersNode.remove();
                            });
                        }

                        Array.from(document.querySelectorAll('main .rh-bookmakers ' + selectedBreakpointUi)).forEach(function (listNode) {
                            return listNode.addEventListener('click', function (e) {
                                if (e.target !== e.currentTarget) return;

                                closeOpenDiscOfferUi();
                            });
                        });

                        Array.from(document.querySelectorAll('main .overlayWrap')).forEach(function (listNode) {
                            return listNode.addEventListener('click', function () {
                                closeOpenDiscOfferUi();
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).filter(function (headerNode) {
                            return !headerNode.closest('.rh-bookmakers__list--web');
                        }).forEach(function (headerNode) {
                            return headerNode.addEventListener('click', function () {
                                var _SegmentIO$trackOffer;

                                var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
                                var bookmakerNode = headerNode.parentNode;
                                var isWebPanel = headerNode.parentNode.parentNode.classList.contains('rh-bookmakers__list--web');
                                var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                // Bet365 comes with uppercase B, but it is required to be lowercase
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var isOverlayOpened = overlay.classList.contains(openedOverlayClass);

                                if (!isOverlayOpened && !isWebPanel) {
                                    overlay.classList.add(openedOverlayClass);
                                    bookmakerListMobile.classList.add(overlayActiveClass);
                                    overlayHeader.classList.add(openedOverlayHeaderClass);
                                }

                                if (openedBookmakerNodes.length > 0) {
                                    Array.from(openedBookmakerNodes).forEach(function (node) {
                                        if (node === bookmakerNode) {
                                            overlay.classList.remove(openedOverlayClass);
                                            if (overlayHeader) {
                                                overlayHeader.classList.remove(openedOverlayHeaderClass);
                                            }
                                            bookmakerNode.classList.remove(openedBookmakerClass);
                                            bookmakerListMobile.classList.remove(overlayActiveClass);

                                            var isPromotedBookmaker = node.getAttribute('promoted-bookmaker');

                                            if (isPromotedBookmaker) {
                                                node.childNodes[1].style.backgroundColor = '';
                                            } else {
                                                node.classList.remove(openedBookmakerClass);

                                                if (isPromotedBookmaker) {
                                                    node.childNodes[1].style.backgroundColor = '';
                                                }
                                            }
                                            bookmakerNode.classList.remove(openedBookmakerClass);
                                            bookmakerListMobile.classList.remove(overlayActiveClass);
                                        } else {
                                            node.classList.remove(openedBookmakerClass);
                                            node.childNodes[1].style.backgroundColor = '';
                                        }
                                    });
                                }

                                if (!isBookmakerNodeOpened) {
                                    bookmakerNode.classList.add(openedBookmakerClass);
                                    var isDiscOffer = bookmakerNode.getAttribute('data-type') === 'discOffer';

                                    if (!isDiscOffer) {
                                        var isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
                                        var bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');

                                        if (isPromotedBookmaker) {
                                            bookmakerNode.childNodes[1].style.backgroundColor = bookmakerColor;
                                        }
                                    } else if (isDiscOffer) {
                                        var _isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
                                        var _bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');

                                        if (_isPromotedBookmaker) {
                                            bookmakerNode.childNodes[3].style.backgroundColor = _bookmakerColor;
                                        }
                                    }
                                }
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, !isBookmakerNodeOpened ? OPEN : CLOSE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackOffer), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn-analytics')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                var _SegmentIO$trackBookm;

                                var bookmakerNode = el.parentNode.parentNode;
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmaker__btn_claim_header')).forEach(function (el) {
                            return el.addEventListener('click', function (e) {
                                var _SegmentIO$trackBookm2;

                                e.stopPropagation();
                                var bookmakerNode = el.parentNode.parentNode;
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE_QUICK_LINK), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm2), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmakers__sub-heading-allOffers')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE));
                            });
                        });

                        Array.from(document.querySelectorAll('.freeBets__Anchor')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                SegmentIO.trackFreeBetsTap({});
                            });
                        });

                        Array.from(document.querySelectorAll('.bookmakersTierTwo__subHeadingTextAllOffers')).forEach(function (anchor) {
                            if (!anchor) return;

                            anchor.addEventListener('click', function () {
                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE));
                            });
                        });

                        Array.from(document.querySelectorAll('.bookmakersTierTwo__bookmaker')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                var _SegmentIO$trackBookm3;

                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(el.getAttribute('bookmaker-name'));
                                var bookmakerPosition = Number(el.getAttribute('bookmaker-position'));
                                var bookmakerOffer = el.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm3 = {}, _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_TIER, tierTwo), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm3), true);
                            });
                        });

                    case 37:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function initBookmakerRegPanel() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = initBookmakerRegPanel;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var chunkArray = exports.chunkArray = function chunkArray(array, chunkSize) {
    var result = [];
    for (var i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tryParseJson = exports.tryParseJson = function tryParseJson(json) {
    try {
        return JSON.parse(json);
    } catch (err) {
        console.log('Error parsing JSON', err);

        return null;
    }
};

var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
    return localStorage.getItem(key);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Reussable global click handler for executing custom code
 * whenever the user clicks outside of the designated target.
 *
 * useCapture is set in order to ensure the document click event
 * is always executed first. Likewise, the event propagation
 * is stopped so as to not retrigger events reattaching
 * another outside click handler.
 *
 * @param {String} target
 * @param {function} callback
 */
// eslint-disable-next-line import/prefer-default-export
var handleClickOutside = exports.handleClickOutside = function handleClickOutside(target, callback) {
    var clickHandler = function clickHandler(e) {
        if (!e.target.closest(target)) {
            callback();
            document.removeEventListener('click', clickHandler, true);
        }
    };

    document.addEventListener('click', clickHandler, true);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var shuffleArray = exports.shuffleArray = function shuffleArray(items, seed) {
    var arr = [].concat(_toConsumableArray(items));
    var currentIndex = arr.length;
    var temporaryValue = void 0;
    var randomIndex = void 0;

    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
    // A simple formula used to generate a sequence of pseudo-random numbers.
    var random = function random(max) {
        var newSeed = (seed * 9301 + 49297) % 233280;
        return Math.floor(newSeed / 233280 * max);
    };

    while (currentIndex !== 0) {
        randomIndex = random(currentIndex);
        currentIndex -= 1;
        temporaryValue = arr[currentIndex];
        arr[currentIndex] = arr[randomIndex];
        arr[randomIndex] = temporaryValue;
    }

    return arr;
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=rpbettingspecialoffer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/lib/rpbettingspecialoffer.js
// module id = 759
// module chunks = 0